import dom from "../../../../dist/jsx-render/dom";
import { ICustomerServive, CustomButtonHandler } from "../../../Frame/CustomerService/ICustomerService";
import { DynamicController } from "../../../Controls/Dynamic/DynamicController";
import { DoubleControl } from "../../../Controls/Dynamic/DoubleControl";
import { CategoryContent } from "../../Admin/Measures/Models/CategoryContent";
import { RadioButtonComponent } from "../../../Components/RadioButtonComponent";
import { MeasureEditFactory } from "../../../Pages/Measure/MeasureEditFactory";
import { PopupCloseType, PagePopup } from "../../../Controls/PagePopup";
import { LinkMeasuresControl } from "../../../Controls/Dynamic/LinkMeasuresControl";
import { MeasureEdit } from "../../../Pages/Measure/MeasureEdit";
import { MeasureListControl } from "../../../Controls/Dynamic/MeasureListControl";
import { app } from "../../../Frame/App";
import { YesNoControl } from "../../../Controls/Dynamic/YesNoControl";
import { CheckboxControl } from "../../../Controls/Dynamic/CheckboxControl";
import { MsoTable } from "../../../Controls/Table/MsoTable";
import { TextControl } from "../../../Controls/Dynamic/TextControl";
import { DynPopup } from "../../../Components/DynPopup";

export class VattenfallCustomerService implements ICustomerServive {
    private kennzifferManualStatus: { [id: number]: boolean };
    private kennzifferCategoryInternalName: string;
    private schriftstueckTemplateId: number;
    private currentIdentNumber: string;

    public hasCustomButton = true;

    constructor() {
        let hiddenCategoryManualAutoInternalName = document.getElementById("CategoryManualAutoInternalName") as HTMLInputElement;
        if (hiddenCategoryManualAutoInternalName) {
            this.kennzifferCategoryInternalName = hiddenCategoryManualAutoInternalName.value;
        }

        let hiddenSchriftstueckTemplateId = document.getElementById("SchriftstueckTemplateId") as HTMLInputElement;
        if (hiddenSchriftstueckTemplateId) {
            let templateId = Number(hiddenSchriftstueckTemplateId.value);
            if (!isNaN(templateId)) {
                this.schriftstueckTemplateId = templateId;
            }
        }

        let identNumberField = document.querySelector("[data-internal-name=identNr]") as HTMLInputElement;
        if (identNumberField) {
            this.SetupIdentNumberCheck(identNumberField);
        }
    }

    public onChangeCategory = (dynamicController: DynamicController, internalName: string, categoryId: number, categoryContentId: number) => {
        if (this.kennzifferCategoryInternalName && internalName == this.kennzifferCategoryInternalName) {
            // Check if the newly selected Kennziffer hat automatic or manual generation of the Vorgangsnummer
            // On Edit.cshtml, there should be a json object present, that has the manual/auto status of the individual category contents
            if (!this.kennzifferManualStatus) {
                let hiddenKennzifferManualStatus = document.getElementById("JsonKennzifferManualStatus") as HTMLInputElement;
                if (hiddenKennzifferManualStatus) {
                    this.kennzifferManualStatus = JSON.parse(hiddenKennzifferManualStatus.value);
                } else {
                    return;
                }
            }

            // true == manual creation of Vorgangsnummer, false = automatic creation
            if (!this.kennzifferManualStatus[categoryContentId]) {

                // delete values from the fields Jahr and Nummer whenever a new Kennziffer with automatic creation is selected. 
                let doubleField: DoubleControl;
                for (let fieldId in dynamicController.controls) {
                    let field = dynamicController.controls[fieldId];
                    if (/*field.internalName == "jahr" ||*/ field.internalName == "nummer") {
                        doubleField = field as DoubleControl;
                        doubleField.setValue(null);
                    }
                }
            }

            for (let fieldId in dynamicController.controls) {
                let field = dynamicController.controls[fieldId];

                // Set the visibility of the appropriate fields regarding to manual/automatic Vorgangsnummer generation.
                if (field.internalName == "autoNummer") {
                    if (this.kennzifferManualStatus[categoryContentId]) {
                        // hide the autoNummer field
                        field.setVisibility(false);
                    } else {
                        // show the autoNummer field
                        field.setVisibility(true);
                    }
                } else if (field.internalName == "jahr" || field.internalName == "nummer") {
                    if (this.kennzifferManualStatus[categoryContentId]) {
                        // show the fieds jahr and nummer
                        field.setVisibility(true);
                    } else {
                        // hide the fields jahr and nummer
                        field.setVisibility(false);
                    }
                }
            }


        }
    }

    public onOpenMeasure = (measureId: string, templateInternalName: string, measureEdit: MeasureEdit, initMeasure: boolean) => {
        // When a Schriftstück is created from an Offener Punkt, the measure List of Schriftstücke should be updated on the root Vorgang (if it's opened)

        if (templateInternalName == "vorgang-lop") {
            console.log("Setting up deferred popup close event.");
            let activePopup = PagePopup.getActivePopup();
            // Setup the deferred onClose action of the active PagePopup
            activePopup.props.popupId = "vorgang";
            activePopup.props.deferredOnClose = (reason: PopupCloseType, id: number) => {
                if (reason == "save") {

                    // Get measure list of Schriftstücke
                    let measureListToUpdate = measureEdit.controls.getControlByInternalName("schriftstücke") as MeasureListControl;
                    if (measureListToUpdate) {
                        measureListToUpdate.addRow(id);
                    }
                }
            };

            console.log("Setting up event handler on list of open points.");
            let tableOpenPoints = MsoTable.allTables["customView64"];
            if (tableOpenPoints) {
                tableOpenPoints.props.onCloseEditPopup = (reason: PopupCloseType, id: number) => {
                    // Get the field "Alle OP geschlossen" and reload its value from the server
                    let control = measureEdit.controls.getControlByInternalName("alleOpAbgeschlossen");
                    if (control) {
                        (control as YesNoControl).updateValueFromServer();
                    }
                }
            }


        } else if (templateInternalName == "schriftstück" && measureId == "0") {
            console.log("Setting up ancestorId of active popup.");
            let activePopup = PagePopup.getActivePopup();
            // Setting the ancestorId will cause the active popup to look for the ancestor popup with this id and execute its deferredOnClose handler.
            activePopup.props.ancestorId = "vorgang";
        }

    }

    public categoryContentAdditionalControls = (categoryInternalName: string, model: CategoryContent, updateContentAction: (content: CategoryContent) => void): HTMLDivElement => {
        if (categoryInternalName == this.kennzifferCategoryInternalName) {

            let attributes: VattenfallCategoryContentAttributes = {
                kennzifferManualNumberGeneration: false
            };

            if (model.attributesJson) {
                try {
                    attributes = JSON.parse(model.attributesJson);
                } catch (err) {
                    console.log(err);
                }
            }

            return <div>
                <RadioButtonComponent model={attributes}
                    field="kennzifferManualNumberGeneration"
                    inline={true}
                    name="Erstellung der Vorgangsnummer"
                    options={[
                        { value: 0, description: "Automatisch" },
                        { value: 1, description: "Manuell" }
                    ]}
                    isBoolean={true}
                    changeEvent={(event: Event) => {
                        this.onChangeKennzifferGeneration(event, model, attributes);
                        updateContentAction(model);
                    }}
                />
            </div>;
        }
        return null;
    }

    private onChangeKennzifferGeneration = (event: Event, model: CategoryContent, attributes: VattenfallCategoryContentAttributes) => {
        model.attributesJson = JSON.stringify(attributes);
    }

    /** Function for custom button
     * 
     * Create a new measure of type "Schriftstück" and after saving, add it to a "Link to Measures" list below. This function is needed in several places.
     * It works using internal names in a specific fashion: the CustomButton will have an internal name xxx, the respecitve "Link to Measures" 
     * field needs to have xxx_ltm as internal name.
    */
    public createSchriftstueck: CustomButtonHandler = (event: Event, internalName: string, measureId: number, parentId: number, dynamicController: DynamicController) => {
        let linkToMeasuresInternalName = internalName + "_ltm";

        let numberFromParentControl = dynamicController.getControlByInternalName("idVorgang") as DoubleControl;
        let vorgangId = numberFromParentControl.getValue(0) as number;

        MeasureEditFactory.showMeasure({
            measureId: 0,

            // Id of the template with the internal name schriftstück
            templateId: this.schriftstueckTemplateId,

            // ParentId of the current "offener Punkt"
            parentId: vorgangId,
            parentGuid: null,
            fullScreen: true,
            onClose: (reason: PopupCloseType, id: number) => {
                if (reason == "save") {
                    // Create a link in the Link to Measures field below
                    let linkSchriftstuecke = dynamicController.getControlByInternalName(linkToMeasuresInternalName) as LinkMeasuresControl;
                    if (linkSchriftstuecke) {
                        // Add the measure that was created above to this control
                        linkSchriftstuecke.addItem(id);
                    }
                }
            }
        });


    }

    /** Function for custom button
    * 
    * Functionality to close the Vorgang measure
   */
    public openCloseVorgang: CustomButtonHandler = (event: Event, internalName: string, measureId: number, parentId: number, dynamicController: DynamicController) => {
        let vorgangFinished = (document.getElementById("hiddenMeasureFinished") as HTMLInputElement)?.value
        if (!vorgangFinished || vorgangFinished != 'True') {
            // Close Vorgang
            let allOffenePunkteClosed = dynamicController.getControlByInternalName("alleOpAbgeschlossen") as YesNoControl;
            if (allOffenePunkteClosed && allOffenePunkteClosed.isValueYes()) {
                let statusFinished = dynamicController.getControlByInternalName("vorgangFinished") as CheckboxControl;
                if (statusFinished) {
                    statusFinished.check();
                }

                const buttonSave = document.getElementById("buttonSave");
                if (buttonSave) {
                    buttonSave.click();
                }
            }
            else {
                app.showDialog(Resources.Common.notAllOpenPointsAreClosed);
            }
        }
        else {
            // Open Vorgang
            let statusFinished = dynamicController.getControlByInternalName("vorgangFinished") as CheckboxControl;
            if (statusFinished && statusFinished.isChecked()) {
                $.ajax({
                    url: app.resolveUrl(`~/api/Vattenfall/openVorgang/${measureId}/${statusFinished.templateBlockId}`),
                    type: 'POST',
                    contentType: "application/json",
                    success: () => {
                        location.reload();
                    },
                    error: (err) => {
                        console.log(err);
                        alert(err);
                    },
                });
            }
        }
    }

    public getDocumentTreeCustomColumns = (): string => {
        return "download;measureId;measureTitle;contents;comment;annotation;userName;date;delete";
    }

    public onChangeDoubleControl = (dynamicController: DynamicController, control: DoubleControl, internalName: string, measureId: number) => {
        if (internalName == "jahr" || internalName == "nummer") {
            let kennziffer: number;
            let jahr: number;
            let nummer: number;

            // Check if the manual vorgangsnummer already exists
            let kennzifferControl = dynamicController.getCategoryControlByInternalName("kennziffer");
            if (kennzifferControl) {
                kennziffer = kennzifferControl.getValue(0);
            }

            let jahrField = dynamicController.getControlByInternalName("jahr");
            if (jahrField) {
                jahr = jahrField.getValue(0);
            }

            let nummerField = dynamicController.getControlByInternalName("nummer");
            if (nummerField) {
                nummer = nummerField.getValue(0);
            }

            $.ajax({
                url: app.resolveUrl(`~/api/vattenfall/vorgangsnummerExists/${kennziffer}/${jahr}/${nummer}/${measureId}`),
                method: "GET",
                success: (response) => {

                    let buttonSave = document.getElementById("buttonSave") as HTMLButtonElement;
                    let buttonSaveAndClose = document.getElementById("buttonSaveAndClose") as HTMLButtonElement;

                    if (response == "true" || response == true) {
                        DynPopup.ShowDialog("Diese Vorgangsnummer existiert bereits. Bitte wählen Sie eine andere Nummer.");

                        // Enable Buttons "Save" and "Save and close"
                        if (buttonSave) buttonSave.disabled = true;
                        if (buttonSaveAndClose) buttonSaveAndClose.disabled = true;

                    } else {
                        // Enable Buttons "Save" and "Save and close"
                        if (buttonSave) buttonSave.disabled = false;
                        if (buttonSaveAndClose) buttonSaveAndClose.disabled = false;
                    }
                },
                error: (err) => {
                    DynPopup.ShowDialog("Ein Fehler ist aufgetreten. Es konnte nicht bestimmt werden, ob diese Vorgangsnummer schon existiert.");
                }
            });

        }
    }

    private SetupIdentNumberCheck = (identNumberField: HTMLInputElement) => {
        this.addLinkToExistingMeasuresVisibility(false);

        identNumberField.onfocus = (event: FocusEvent) => {
            let currentElement = event.currentTarget as HTMLInputElement;
            this.currentIdentNumber = currentElement?.value;
        };

        identNumberField.onblur = (event: FocusEvent) => {
            let currentElement = event.currentTarget as HTMLInputElement;
            let currentValue = currentElement?.value;
            if (currentValue != undefined && currentValue != null && currentValue != ''
                && (!this.currentIdentNumber || currentValue != this.currentIdentNumber)) {
                $.ajax({
                    url: app.resolveUrl(`~/api/Vattenfall/isUniqueIdentNumber/${currentValue}/${this.schriftstueckTemplateId}`),
                    type: 'GET',
                    contentType: "application/json",
                    success: (result) => {
                        if (result) {
                            this.addLinkToExistingMeasuresVisibility(false);
                        }
                        else {
                            app.showDialog(Resources.Common.notUniqueIdentNumber.replace("%IndentNumber%", currentValue));
                            this.preSelectFilter(currentValue);
                            this.addLinkToExistingMeasuresVisibility(true);
                        }
                    },
                    error: (err) => {
                        console.log(err);
                        alert(err);
                    },
                });
            }
        };
    }

    private addLinkToExistingMeasuresVisibility = (visible: boolean) => {
        let linkToExistingMeasures = document.querySelector("[data-internal-name=identNr_measures]") as HTMLInputElement;
        if (linkToExistingMeasures.value == '[]') {
            let container = linkToExistingMeasures?.parentElement?.parentElement?.parentElement?.parentElement;
            if (container) {
                if (visible) {
                    container.classList.remove("d-none");
                }
                else {
                    container.classList.add("d-none");
                }
            }
        }
    }

    private preSelectFilter = (filter: string) => {
        let linkToExistingMeasures = document.querySelector("[data-internal-name=identNr_measures]") as HTMLInputElement;
        if (linkToExistingMeasures?.parentElement) {
            let relatedObjectsList = linkToExistingMeasures.parentElement.querySelector(".related-objects") as HTMLElement;
            if (relatedObjectsList) {
                if (filter) {
                    relatedObjectsList.setAttribute("preSelectedSearchTerm", filter);
                }
                else {
                    if (relatedObjectsList.hasAttribute("preSelectedSearchTerm")) {
                        relatedObjectsList.removeAttribute("preSelectedSearchTerm");
                    }
                }
            }
        }
    }
}

export class VattenfallCategoryContentAttributes {
    kennzifferManualNumberGeneration: boolean;
}